import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Invoices.frontend.types'

@Injectable({ providedIn: 'root' })
export class Invoices_update_auto_invoice_rule_schedule_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { schedule_name: string, cron_expression: string, rule_id: string }): Promise<{ reasons?: string[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.schedule_name)) {
      missingRequiredInParams.push('\'schedule_name\'');
    }
    if (isNil(inParams.cron_expression)) {
      missingRequiredInParams.push('\'cron_expression\'');
    }
    if (isNil(inParams.rule_id)) {
      missingRequiredInParams.push('\'rule_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/functions/update_auto_invoice_rule_schedule_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

